import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { EDBService } from "$services";
import EDBFormInside from "./EdbFormInside";
import { Loader } from "$components/Layout/Loader";
import { CacheInvalidationAction } from "$utils/cache";
import { EdbProvider } from "./context/EdbContext";
import { EDBFormProvider } from "./context/EDBFormContext";

function EDBForm() {
  const { idEdb } = useParams<"idEdb">();

  const { data, isLoading } = useQuery({
    queryKey: [CacheInvalidationAction.GET_EDB_BY_ID, idEdb],
    queryFn: () => EDBService.getEdbById(idEdb),
    enabled: !!idEdb,
    gcTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return <Loader />;
  }

  return (
    <EdbProvider>
      <EDBFormProvider idEdb={idEdb} currentEdb={data}>
        <EDBFormInside />
      </EDBFormProvider>
    </EdbProvider>
  );
}

export default EDBForm;
